/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_Sentence_TodayInputs */

const vi_einvoice_pending_sentence_today = /** @type {(inputs: Einvoice_Pending_Sentence_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vừa giao hôm nay, chưa xuất hóa đơn.`)
};

/**

* @param {Einvoice_Pending_Sentence_TodayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_sentence_today = /** @type {((inputs?: Einvoice_Pending_Sentence_TodayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_Sentence_TodayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_sentence_today(inputs)
});